/* eslint-disable import/no-extraneous-dependencies */
import { nanoid } from "nanoid";

const getVisitorId = () => {
  if (typeof localStorage !== "undefined") {
    let visitor_id = localStorage.getItem("visitor_id");
    if (!visitor_id) {
      visitor_id = nanoid();
      localStorage.setItem("visitor_id", visitor_id);
    }
    return visitor_id;
  }
  return nanoid();
};

export default getVisitorId;
